const BREADCRUMB_KEY = "theme-breadcrumbs";

const saveBreadcrumb = () => {
  const oldData = JSON.parse(
    window.sessionStorage.getItem(BREADCRUMB_KEY) || "{}"
  );

  try {
    const pageData = {
      current: JSON.parse(document.querySelector("[data-page-data]").innerHTML),
      previous: oldData.current,
    };

    window.sessionStorage.setItem(BREADCRUMB_KEY, JSON.stringify(pageData));
  } catch (error) {
    console.warn("unable to save breadcrumb", error);
  }
};

saveBreadcrumb();

class DynamicBreadcrumb extends HTMLElement {
  constructor() {
    super();

    try {
      const pageData = window.sessionStorage.getItem(BREADCRUMB_KEY);
      if (pageData) {
        const { previous } = JSON.parse(pageData);
        if (!previous) return;

        const { path, page_type, title } = previous;
        if (page_type !== this.type) return;

        const dynamicLink = this.querySelector("[data-dynamic-link]");

        dynamicLink.href = path;
        dynamicLink.innerHTML = title;
      }
    } catch (error) {
      console.warn("unable to read breadcrumb data", error);
    }
  }

  get type() {
    return this.getAttribute("type");
  }
}

if (!customElements.get("dynamic-breadcrumb")) {
  customElements.define("dynamic-breadcrumb", DynamicBreadcrumb);
}
